import React, { ForwardedRef } from "react";
import "./button.css";

type Variant = "primary" | "ghost" | "subtle" | "success" | "warn" | "danger";
type Size = "sm" | "md" | "lg";

interface Props {
  children: React.ReactNode;
  onClick?: () => void | Promise<void>;
  variant?: Variant;
  size?: Size;
  icon?: React.ReactNode;
  disabled?: boolean;
  className?: string;
  type?: "button" | "submit" | "reset";
}

const Button = React.forwardRef<HTMLButtonElement, Props>(
  (
    { children, onClick, variant = "primary", size = "md", icon, disabled, className = "", type = "button" },
    ref: ForwardedRef<HTMLButtonElement>
  ) => (
    <button
      ref={ref}
      type={type}
      className={`v1-btn v1-btn--${variant} v1-btn--${size}${className ? ` ${className}` : ""}`}
      onClick={onClick}
      disabled={disabled}
    >
      {icon && <span className="v1-btn-icon">{icon}</span>}
      {children}
    </button>
  )
);

export default Button;
